import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { isEmpty } from 'lodash';

// REDUX
import { selectLocalSessionId } from 'redux/onBoarding/selector';

// CONSTANT
import { Router } from 'constant';

import { useAppSelector } from './redux';

// Every onboarding step past Welcome depends on in-memory wizard state (nric, lovedOne, b3Snapshot,
// linkpassPrefill, ...) that lives only in redux, unpersisted. A full page refresh resets that
// state, so resuming mid-wizard would render blank/broken forms - instead we bounce back to Welcome
// so the user restarts the flow from scratch.
//
// localSessionId (not the backend sessionId) is the signal: sessionId gets recreated automatically
// by App.container's checkAccountStatus on every app load regardless of which route is open, so its
// presence doesn't actually mean "this step was reached through the wizard". localSessionId is only
// ever set by Welcome's onSubmit, so it reliably reflects that.
export const useOnboardingSessionGuard = (): boolean => {
  const history = useHistory();
  const localSessionId = useAppSelector(selectLocalSessionId);
  const shouldRedirect = isEmpty(localSessionId);

  useEffect(() => {
    if (shouldRedirect) {
      history.replace(Router.Welcome);
    }
  }, [shouldRedirect, history]);

  return shouldRedirect;
};
